<div class="relativePageContainer">
  <div class="page-container" style="display: flex;">
    <app-gateway-table
      [gateways]="gateways"
      [selectedPartitionId]="selectedPartitionId"
      [selectedRowGateway]="selectedRowGateway"
      [compactMode]="isGatewayTableCompact"
      [class.compact]="isGatewayTableCompact"
      (onGatewayRowClick)="onGatewayRowClick($event)"
      (updateGatewaysRequest)="getGateways($event)"
      (showNewGatewayForm)="showNewGatewayForm()"
      (openEditGatewayDrawer)="openEditGatewayDrawer($event)"
      class="dx-card">
    </app-gateway-table>

    <div [ngClass]="isDeviceOrGatewayDrawerOpen || isGatewayDrawerOpen? '' : 'noShadowOverlay'" class="dx-card"
         style="flex: 1 1 0;
         min-width: 0;
         display: flex;
         flex-direction: column;
         height: auto;
         padding: 0;
         align-items: center;">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [opened]="isDeviceOrGatewayDrawerOpen || isGatewayDrawerOpen"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        style="border-radius: 10px;"
        template="template">
        <div *dxTemplate="let data of 'template'" [style.width.px]="setWidthOfDrawerPx()" class="drawerInnerContent"
             style="border-radius: 10px;">
          <div *ngIf="isGatewayDrawerOpen && !!editedGateway" [style.width.px]="setWidthOfDrawerPx()"
               class="drawerTitleWrapper">
            <h2 class="gatewayName">{{ selectedGateway?.name }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button
                (onClick)="getNetInterfacePasswordGateway()"
                *ngIf="!isEditMode && (selectedGateway?.status === GatewayStatusEnum.DEVICES_CONFIGURED
                || selectedGateway?.status === GatewayStatusEnum.CONFIG_NEEDS_UPDATING
                || selectedGateway?.status === GatewayStatusEnum.UPDATING_CONFIG)"
                [type]="'default'" id="getNetInterfacePasswordButton">
                <i class="vr-ic_fluent_key_24_regular" style="margin-right: 8px; font-size: 18px"></i>
                <span class="dx-button-text">{{ 'REGISTRY.GATEWAY.COPY_GATEWAY_PASSWORD' | translate }}</span>
              </dx-button>
              <dx-button
                (onClick)="enableEditModeGateway()"
                *ngIf="!isEditMode"
                [type]="'default'"
                icon="edit"
                id="editGatewayButton"
                text="{{'BUTTONS.UPDATE' | translate}}">
              </dx-button>
              <dx-button
                (onClick)="deletingGateway = true"
                *ngIf="!isEditMode"
                icon="trash"
                text="{{'BUTTONS.DELETE' | translate}}"
                type="danger">
              </dx-button>
              <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button
                  (onClick)="saveGateway(); focusInvalidTab(editGatewayFormComponent.editGatewayForm)"
                  [disabled]="!isEditFormValid || !gatewayEdited"
                  [stylingMode]="'contained'"
                  [type]="'default'"
                  icon="save" text="{{'BUTTONS.SAVE' | translate}}">
                </dx-button>
                <dx-button
                  (onClick)="disableEditModeGateway();"
                  [type]="'normal'"
                  [stylingMode]="'contained'"
                  icon="revert"
                  text="{{'BUTTONS.CANCEL' | translate}}">
                </dx-button>
              </div>
              <dx-button
                (onClick)="closeDrawer()"
                *ngIf="!isEditMode"
                [type]="'default'"
                [width]="30"
                icon="close">
              </dx-button>
            </div>
          </div>
          <app-gateway-edit-form
            #editGatewayFormComponent
            [editedGateway]="editedGateway"
            [selectedGateway]="selectedGateway"
            [gatewayEditTextOptions]="gatewayEditTextOptions"
            [gatewayEditTextAreaOptions]="gatewayEditTextAreaOptions"
            [gatewayEditNumberOptions]="gatewayEditNumberOptions"
            [gatewayEditCheckBoxOptions]="gatewayEditCheckBoxOptions"
            [gatewayTypes]="gatewayTypes"
            [isEditMode]="isEditMode"
            [selectedGatewayNetConfig]="selectedGatewayNetConfig"
            (isEditFormValid)="isEditFormValid = $event"
            (gatewayEdited)="gatewayEdited = $event"
            *ngIf="isGatewayDrawerOpen && !!editedGateway && !selectedDeviceFull">
          </app-gateway-edit-form>

          <div *ngIf="isDeviceOrGatewayDrawerOpen && !!selectedDeviceFull" [style.width.px]="setWidthOfDrawerPx()"
               class="drawerTitleWrapper">
            <h2>{{ selectedDeviceFull.name }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button
                (onClick)="openTemplateCompare()"
                *ngIf="!isEditMode && !isSelectedDevicePendingDeletion"
                [type]="'default'"
                icon="search"
                id="compareWithTemplateButton"
                text="{{'REGISTRY.DEVICE.TEMPLATE_IMPORT.OPEN_BUTTON' | translate}}">
              </dx-button>
              <span *ngIf="!isEditMode" id="deviceEditDeleteButtons"
                    style="display: flex; flex-direction: row; align-items: center; gap: 10px"
                    [attr.title]="isSelectedDevicePendingDeletion ? ('REGISTRY.DEVICE.TEXT.PENDING_DELETION' | translate) : null">
                <dx-button
                  (onClick)="enableEditModeDevice()"
                  [disabled]="isSelectedDevicePendingDeletion"
                  [type]="'default'"
                  icon="edit"
                  id="editDeviceButton"
                  text="{{'BUTTONS.UPDATE' | translate}}">
                </dx-button>
                <dx-button
                  (onClick)="deletingDevice = true"
                  [disabled]="isSelectedDevicePendingDeletion" icon="trash"
                  text="{{'BUTTONS.DELETE' | translate}}"
                  type="danger">
                </dx-button>
              </span>
              <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button
                  (onClick)="saveDevice(); focusInvalidTab(editDeviceFormComponent.editDeviceForm)"
                  [disabled]="!isEditFormValid || !deviceEdited"
                  [stylingMode]="'contained'"
                  [type]="'default'"
                  icon="save"
                  text="{{'BUTTONS.SAVE' | translate}}">
                </dx-button>
                <dx-button
                  (onClick)="disableEditModeDevice();"
                  [type]="'normal'"
                  [stylingMode]="'contained'"
                  icon="revert"
                  text="{{'BUTTONS.CANCEL' | translate}}">
                </dx-button>
              </div>
              <dx-button
                (onClick)="closeDrawer()"
                *ngIf="!isEditMode"
                [type]="'default'"
                [width]="30"
                icon="close">
              </dx-button>
            </div>
          </div>

          <app-device-edit-form
            #editDeviceFormComponent
            [editedDeviceFull]="editedDeviceFull"
            [selectedDeviceFull]="selectedDeviceFull"
            [selectedGateway]="selectedGateway"
            [deviceEditTextOptions]="deviceEditTextOptions"
            [deviceEditTextAreaOptions]="deviceEditTextAreaOptions"
            [deviceEditNumberOptions]="deviceEditNumberOptions"
            [deviceEditCheckBoxOptions]="deviceEditCheckBoxOptions"
            [selectedRowMetricGroup]="selectedRowMetricGroup"
            [deviceTypes]="deviceTypes"
            [(selectedMetricGroup)]="selectedMetricGroup"
            [isEditMode]="isEditMode"
            (isEditFormValid)="isEditFormValid = $event"
            (deviceEdited)="deviceEdited = $event"
            *ngIf="isDeviceOrGatewayDrawerOpen && !!selectedDeviceFull">
          </app-device-edit-form>

        </div>

        <app-device-table
          (onDeviceRowClick)="onDeviceRowClick($event)"
          (showNewDeviceForm)="showNewDeviceForm()"
          (updateDevicesRequest)="getDevices()"
          [selectedGateway]="selectedGateway"
          [selectedGatewayDevices]="selectedGateway? selectedGateway.devices : undefined"
          [selectedRowDevice]="selectedRowDevice"
          [isGatewayDrawerOpen]="isGatewayDrawerOpen"
          [isGatewayPendingConfig]="selectedGateway?.status !== GatewayStatusEnum.UPDATING_CONFIG"
          class="drawerOuterContent">
        </app-device-table>

      </dx-drawer>
    </div>

  </div>
</div>


<dx-popup
  [(visible)]="deletingDevice"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [height]="200"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.DEVICE.TEXT.DELETE_DEVICE' | translate"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="deleteDevice()"
      [height]="40"
      icon="trash"
      text="{{'BUTTONS.DELETE' | translate}}"
      type="danger">
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="deletingDevice = false"
      [height]="40"
      [stylingMode]="'outlined'"
      icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}">
    </dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <span
      [innerHTML]="'REGISTRY.DEVICE.TEXT.CONFIRM_DELETE' | translate : {deviceName: selectedDeviceFull?.name}"
      style="font-size: 18px">
    </span>
  </div>
</dx-popup>

<app-device-template-compare
  *ngIf="!!selectedDeviceFull"
  [(visible)]="templateCompareVisible"
  [deviceId]="selectedDeviceFull.id!"
  [deviceTypes]="deviceTypes"
  [deviceProtocol]="selectedDeviceFull.protocolType!"
  [defaultDeviceTypeId]="selectedDeviceFull.typeId"
  [defaultType]="selectedDeviceFull.defaultType"
  [templateGroups]="templateCompareGroups"
  [deviceGroups]="deviceCompareGroups"
  (selectedDeviceTypeIdChange)="onCompareDeviceTypeChange($event)"
  (addGroup)="onCompareAddGroup($event)"
  (addMetric)="onCompareAddMetric($event)"
  (replaceMetric)="onCompareReplaceMetric($event)"
  (deleteGroup)="onCompareDeleteGroup($event)"
  (deleteMetric)="onCompareDeleteMetric($event)"
  (saveCompare)="onCompareSave($event)"
  (cancelCompare)="onCompareCancel()"
  (resetFromModel)="resetDeviceFromModel($event)">
</app-device-template-compare>

<app-device-create-form
  [(addDevice)]="addDevice"
  [newDevice]="newDevice"
  [selectedGateway]="selectedGateway"
  [selectedRowMetricGroup]="selectedRowMetricGroup"
  [(selectedMetricGroup)]="selectedMetricGroup"
  [deviceTypes]="deviceTypes"
  (isNewFormValid)="isNewFormValid = $event"
  (putDevice)="putDevice($event)">
</app-device-create-form>

<dx-popup
  [(visible)]="deletingGateway"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [height]="200"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.GATEWAY.TEXT.DELETE_GATEWAY' | translate"
  [width]="660">
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="deleteGateway()"
      [height]="40"
      icon="trash"
      text="{{'BUTTONS.DELETE' | translate}}"
      type="danger">
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom">
    <dx-button
      (onClick)="deletingGateway = false"
      [height]="40"
      [stylingMode]="'outlined'"
      icon="close"
      text="{{'BUTTONS.CANCEL' | translate}}">
    </dx-button>
  </dxi-toolbar-item>
  <div style="height: 100%; display: flex; align-items: center;">
    <span
      [innerHTML]="'REGISTRY.GATEWAY.TEXT.CONFIRM_DELETE' | translate : {gatewayName: selectedGateway?.name}"
      style="font-size: 18px">
    </span>
  </div>
</dx-popup>

<app-gateway-create-form
  [(addGateway)]="addGateway"
  (putGateway)="putGateway($event)"
  (resetSelectedRowPartitionNewGatewayForm)="selectedRowPartitionNewGatewayForm = undefined"
  [newGateway]="newGateway"
  [isNewFormValid]="isNewFormValid"
  [gatewayTypes]="gatewayTypes">
</app-gateway-create-form>

